import { useEffect, useMemo, useState } from "react";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { getData } from "../../../api/ApiRest";
import { Button, Card, FloatingLabel, Form } from "react-bootstrap";
import { Grid, Paper, Typography } from "@mui/material";
import { FaEye, FaSave } from "react-icons/fa";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../widgets/FormatNumber";

function AutoGestion() {
    const [loading, setLoading] = useState(false);
    const [dataEmpresa, setDataEmpresa] = useState({});
    const [planes, setPlanes] = useState([]);

    const [archivoRut, setArchivoRut] = useState(null);
    const [archivoCCIO, setArchivoCCIO] = useState(null);
    const [archivoCedula, setArchivoCedula] = useState(null);

    const infoUser = useSelector((state) => state.auth);

    useEffect(() => {
        obtenerInformacionCliente();

        documentosLegalCargar();
    }, []);

    ///Función para obtener la información basica de un cliente
    const obtenerInformacionCliente = () => {
        setLoading(true);

        getData('api/Configuracion/Company/obtenerInfoCliente').then(response => {

            setTimeout(() => {
                setDataEmpresa(response.infoCliente);
            }, 1000)

            setPlanes(response.infoPlanes);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const enviarInfoGestion = () => {
        setLoading(true);

        const formData = new FormData();
        formData.append("renovacionCompany.CCIO", archivoCCIO);
        formData.append("renovacionCompany.CEDULA", archivoCedula);
        formData.append("renovacionCompany.Rut", archivoRut);
        formData.append("renovacionCompany.RenovacionCompany.direccion", dataEmpresa.direccion);
        formData.append("renovacionCompany.RenovacionCompany.dv", dataEmpresa.dv);
        formData.append("renovacionCompany.RenovacionCompany.correo", dataEmpresa.correo);
        formData.append("renovacionCompany.RenovacionCompany.razonsocial", dataEmpresa.razonsocial);
        formData.append("renovacionCompany.RenovacionCompany.recomendacionPlanId", dataEmpresa.recomendacionPlanId);
        formData.append("renovacionCompany.RenovacionCompany.telefono", dataEmpresa.telefono);
        formData.append("renovacionCompany.RenovacionCompany.ciudad", dataEmpresa.ciudad);
        formData.append("renovacionCompany.RenovacionCompany.rut_Detalle", dataEmpresa.rut_Detalle);
        formData.append("renovacionCompany.RenovacionCompany.identificacion", dataEmpresa.identificacion);
        formData.append("renovacionCompany.RenovacionCompany.camaraComercioDetalle", dataEmpresa.camaraComercioDetalle);
        formData.append("renovacionCompany.RenovacionCompany.cedulaRepLegal_Detalle", dataEmpresa.cedulaRepLegal_Detalle);
        formData.append("renovacionCompany.RenovacionCompany.precioAnual", dataEmpresa.precioAnual);
        formData.append("renovacionCompany.RenovacionCompany.precioMensual", dataEmpresa.precioMensual);

        const AmbienteTae_Url = infoUser.AmbienteTae_Url;

        let UrlBase = AmbienteTae_Url +
            'api/Configuracion/Company/cargarSolicitud';


        ///Pendiente asignar token aqui
        const token = infoUser.tokenSesion; //localStorage.getItem('tokenSesion');

        fetch(UrlBase, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json'
            },
            body: formData
        }).then(response => response.json())
            .then(data => {
                if (data.status) {
                    alert('Registros ingresado correctamente');
                }else{
                    console.log(data);
                }

                setLoading(false);
            })
            .catch(error => {
                alert('Algo salio mal en la peticion');
                console.log(error);
                setLoading(false);
            });
    }

    const documentosLegalCargar = () => {
        setLoading(true);

        getData('api/Configuracion/Company/DocumentosLegalesGet', {
            CompanyId: infoUser.CompanyId
        }).then(response => {
            setDataEmpresa({
                ...dataEmpresa,
                rut_Detalle: response.modelo.rut_Detalle.arhivoNombre,
                camaraComercioDetalle: response.modelo.camaraComerciao_Detalle.arhivoNombre,
                cedulaRepLegal_Detalle: response.modelo.cedulaRepLegal_Detalle.arhivoNombre
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal al cargar los documentos legales');
        })
    }

    const openNewTab = (URL = '') => {
        window.open(URL, '_blank');
    }

    const datosEmpresaMemo = useMemo(() => {
        if (!dataEmpresa) {
            return {
                precioAnual: null,
                precioMensual: null,
                total: null
            };
        }

        return {
            precioAnual: Number(dataEmpresa.precioAnual),
            precioMensual: Number(dataEmpresa.precioMensual),
            total: Number(dataEmpresa.precioAnual) + 110000
        };
    }, [dataEmpresa])

    return <div className='BodyComponent'>
        {<LoadingComponent Loading={loading} />}

        <Grid container spacing={3} style={{ marginTop: -50 }}>
            <Grid item xs={12} md={9}>
                <Paper sx={{ p: 1, borderRadius: 3 }}>

                    <div className="row">
                        <div className="col-md-3">
                            <FloatingLabel controlId="identificacion" label="Identificación">
                                <Form.Control
                                    as="input"
                                    type="text"
                                    value={dataEmpresa.identificacion}
                                    readOnly
                                />
                                <Form.Control
                                    as="input"
                                    type="text"
                                    value={dataEmpresa.dv}
                                    hidden
                                />
                            </FloatingLabel>
                        </div>
                        <div className="col-md-6">
                            <FloatingLabel controlId="razonsocial" label="Razón social">
                                <Form.Control
                                    as="input"
                                    type="text"
                                    value={dataEmpresa.razonsocial}
                                    readOnly
                                />
                            </FloatingLabel>
                        </div>
                        <div className="col-md-3">
                            <FloatingLabel controlId="dirección" label="Dirección">
                                <Form.Control
                                    as="input"
                                    type="text"
                                    value={dataEmpresa.direccion}
                                    readOnly
                                />
                            </FloatingLabel>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-md-4">
                            <FloatingLabel controlId="correo" label="Correo">
                                <Form.Control
                                    as="input"
                                    type="text"
                                    value={dataEmpresa.correo}
                                    readOnly
                                />
                            </FloatingLabel>
                        </div>
                        <div className="col-md-2">
                            <FloatingLabel controlId="telefono" label="Telefono">
                                <Form.Control
                                    as="input"
                                    type="text"
                                    value={dataEmpresa.telefono}
                                    readOnly
                                />
                            </FloatingLabel>
                        </div>
                        <div className="col-md-3">
                            <FloatingLabel controlId="ciudad" label="Ciudad">
                                <Form.Control
                                    as="input"
                                    type="text"
                                    value={dataEmpresa.ciudad}
                                    readOnly
                                />
                            </FloatingLabel>
                        </div>
                        <div className='col-md-3'>
                            <FloatingLabel
                                controlId='plan'
                                label="Plan recomendado"
                                className="mb-2"
                            >
                                <Form.Select
                                    value={dataEmpresa.recomendacionPlanId}
                                    onChange={event => {
                                        const valor = planes.filter(x => x.id === event.target.value)[0];

                                        setDataEmpresa({
                                            ...dataEmpresa,
                                            recomendacionPlanId: event.target.value,
                                            precioMensual: valor.valorMes,
                                            precioAnual: valor.valorAnual
                                        });
                                    }}
                                >
                                    <option value="">Seleccione</option>
                                    {planes.map((item, index) =>
                                        <option key={index} value={item.id}>{item.descripcion}</option>
                                    )}
                                </Form.Select>
                            </FloatingLabel>
                        </div>
                    </div>
                    <br />
                    <div className='row'>
                        <div className='col-md-4'>
                            <Card>
                                <Card.Header className='bg-primary text-center text-white'>RUT</Card.Header>
                                <Card.Body>
                                    {dataEmpresa.rut === false ?
                                        <div>
                                            <h4 className='text-danger'>PENDIENTE</h4>
                                        </div>
                                        :
                                        <div className='text-center'>
                                            <button className='btn btn-sm btn-success'
                                                onClick={() => { openNewTab('https://api-pro1.tae-col.com/adjuntos/' + dataEmpresa.rut_Detalle) }}

                                            >
                                                VER RUT <FaEye size={'1rem'} />
                                            </button>
                                        </div>
                                    }
                                    <hr></hr>
                                    <label className="form-label">Cargue de Rut</label>
                                    <input className="form-control" type="file" accept='application/pdf'
                                        onChange={file => {
                                            setArchivoRut(file.target.files[0]);
                                        }}
                                        id="formFile"></input>
                                </Card.Body>
                            </Card>
                        </div>

                        <div className='col-md-4'>
                            <Card>
                                <Card.Header className='bg-primary text-center text-white'>CAMARA Y COMERCIO</Card.Header>
                                <Card.Body>
                                    {dataEmpresa.camaraComercio === false ?
                                        <div>
                                            <h4 className='text-danger'>PENDIENTE</h4>
                                        </div>
                                        :
                                        <div className='text-center'>
                                            <button className='btn btn-sm btn-success'
                                                onClick={() => { openNewTab('https://api-pro1.tae-col.com/adjuntos/' + dataEmpresa.camaraComercioDetalle) }}

                                            >
                                                VER CAMARA Y CCIO <FaEye size={'1rem'} />
                                            </button>
                                        </div>
                                    }
                                    <hr></hr>
                                    <label className="form-label">Cargue de CAMARA Y CCIO</label>
                                    <input className="form-control" type="file" accept='application/pdf'
                                        onChange={file => {
                                            setArchivoCCIO(file.target.files[0]);
                                        }}
                                        id="formFile"></input>
                                </Card.Body>
                            </Card>
                        </div>

                        <div className='col-md-4'>
                            <Card>
                                <Card.Header className='bg-primary text-center text-white'>CEDULA</Card.Header>
                                <Card.Body>
                                    {dataEmpresa.cedulaRepLegal === false ?
                                        <div>
                                            <h4 className='text-danger'>PENDIENTE</h4>
                                        </div>
                                        :
                                        <div className='text-center'>
                                            <button className='btn btn-sm btn-success'
                                                onClick={() => { openNewTab('https://api-pro1.tae-col.com/adjuntos/' + dataEmpresa.cedulaRepLegal_Detalle) }}

                                            >
                                                VER CEDULA <FaEye size={'1rem'} />
                                            </button>
                                        </div>
                                    }
                                    <hr></hr>
                                    <label className="form-label">Cargue de CEDULA</label>
                                    <input className="form-control" type="file" accept='application/pdf'
                                        onChange={file => {
                                            setArchivoCedula(file.target.files[0]);
                                        }}
                                        id="formFile"></input>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                    <br />
                    <div className="row" style={{ textAlign: 'right' }}>
                        <div className="col-md-12">
                            <Button variant='success' type='button' onClick={() => enviarInfoGestion()}>
                                <FaSave size={'1rem'} />
                            </Button>
                        </div>
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
                <Paper sx={{ borderRadius: 3 }}>
                    <Typography variant="h6" color="primary" fontWeight="bold" style={{ textAlign: 'center' }}>
                        Certificado:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ textAlign: 'center', fontSize: 16 }}>
                        $ 110.000
                    </Typography>
                    <Typography variant="h6" color="primary" fontWeight="bold" style={{ textAlign: 'center' }}>
                        Plan anual:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ textAlign: 'center', fontSize: 16 }}>
                        $ {formatNumber(datosEmpresaMemo.precioAnual)}
                    </Typography>
                    <Typography variant="h6" color="primary" fontWeight="bold" style={{ textAlign: 'center' }}>
                        Plan mensual:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ textAlign: 'center', fontSize: 16 }}>
                        $ {formatNumber(datosEmpresaMemo.precioMensual)}
                    </Typography>
                </Paper>
                <Paper sx={{ p: 1, borderRadius: 3 }} style={{ marginTop: 5 }}>
                    <Typography variant="h6" color="primary" fontWeight="bold" style={{ textAlign: 'center' }}>
                        Total:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ textAlign: 'center', fontSize: 16 }}>
                        $ {formatNumber(datosEmpresaMemo.total)}
                    </Typography>
                    <Typography variant="h8" style={{ textAlign: 'center', fontSize: 12, justifyContent: 'center' }}>
                        <p>Agradecemos realizar la consignación o transferencia del valor correspondiente en la siguiente cuenta bancaria:</p>
                        <p><label style={{ fontWeight: 'bold' }}>Banco:</label> Bancolombia</p>
                        <p><label style={{ fontWeight: 'bold' }}>Tipo de cuenta:</label> Ahorros</p>
                        <p><label style={{ fontWeight: 'bold' }}>Número de cuenta:</label> XXXXXXXX</p>
                        <p><label style={{ fontWeight: 'bold' }}>Titular:</label> XXXXXXXX</p>
                        <p><label style={{ fontWeight: 'bold' }}>Documento:</label> XXXXXXXX</p>
                        <p>Una vez efectuado el pago, le solicitamos enviar el comprobante correspondiente a través de WhatsApp o cargarlo directamente en nuestra plataforma web, con el fin de validar y procesar la transacción oportunamente.</p>
                    </Typography>
                </Paper>
            </Grid>
        </Grid>


    </div>
}

export default AutoGestion;